import { GqlErrorCode, GqlTransaction } from "@penfold/graphql";
import { DataProxy } from "apollo-cache";
import { ApolloError } from "apollo-client";
import gql from "graphql-tag";
import get from "lodash/get";

export const validationErrors = (apolloError) => {
  return get(apolloError, "extensions.exception.validationErrors");
};

const TRANSACTIONS = gql`
  query transactions {
    transactions {
      id
      date
      type
      status
      amount
    }
  }
`;

export const addTransactionToCache = (
  cache: DataProxy,
  transaction: GqlTransaction
) => {
  if (!transaction) {
    return;
  }

  // read existing transactions (if defined)
  const cachedData: any = cache.readQuery({
    query: TRANSACTIONS,
  });

  if (!cachedData.transactions) {
    return;
  }

  // append new transaction to the list
  cachedData.transactions = [...cachedData.transactions, transaction];

  // save it back again
  cache.writeQuery({
    query: TRANSACTIONS,
    data: cachedData,
  });
};

export const getApolloErrorCode = (
  error?: ApolloError
): GqlErrorCode | null => {
  if (!error || !error.graphQLErrors) {
    return null;
  }

  return error.graphQLErrors[0]?.extensions.code;
};
